import { AdjustmentType } from '../models/adjustment-type.enum';

export class AdjustmentUtils {

  static isAdjustmentTypePositive(adjustmentType: AdjustmentType): boolean {
    switch (adjustmentType) {
      case AdjustmentType.PREPAYMENT:
        return false;

      case AdjustmentType.REBATE:
        return true;

      default:
        return true;
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/utils/adjustment-utils.ts